<app-ngx-mat-table
  tableName="Robot Family Metadata Table"
  description="Shows a table of all robot family metadata and enables their manipulation."
  dataType="robot_family_metadata"
  sortActive="robot_family"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
  i18n-tableName
  i18n-description
></app-ngx-mat-table>
